/* @flow */

import * as React from 'react';
import {components, type OptionProps} from 'react-select';

import {Body} from '../typography';

import './option-with-subtitle-and-sublabel.module.css';

export function OptionWithSubtitleAndSublabel(props: OptionProps) {
    return (
        <components.Option {...props}>
            <div className='flex justify-sb align-start'>
                <div styleName='content'>
                    <div styleName='label'>{props.data.label}</div>
                    {props.data.sublabel && (
                        <Body size='tiny' truncate={{type: 'inline'}} color='light'>
                            {props.data.sublabel}
                        </Body>
                    )}
                </div>
                {props.data.subtitle && <div styleName='subtitle'>{props.data.subtitle}</div>}
            </div>
        </components.Option>
    );
}
